import { TApplicationState } from '../../types/redux';

export function getIsMapVisible(state: TApplicationState) {
  return state.common.mapOptions.visible;
}
